<div class="relative">
  <button (click)="togglePanel()" data-testid="bell-btn" class="relative z-50 p-2 text-gray-400 hover:text-white transition-colors">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
    @if (notifications.badgeCount() > 0) {
      <span data-testid="badge-count" class="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
        {{ notifications.badgeCount() }}
      </span>
    }
  </button>

  @if (notifications.panelOpen()) {
    <div data-testid="notification-panel" class="fixed left-1/2 -translate-x-1/2 top-14 mt-2 w-[calc(100vw-1rem)] sm:w-96 sm:absolute sm:left-auto sm:translate-x-0 sm:right-0 sm:top-full bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-96 overflow-y-auto">
      <div class="p-3 border-b border-gray-100">
        <h3 class="text-sm font-semibold text-gray-800">Figyelmeztetések</h3>
      </div>

      @if (notifications.alerts().length === 0) {
        <div class="p-4 text-sm text-gray-500 text-center">
          Nincs figyelmeztetés.
        </div>
      } @else {
        @for (alert of notifications.alerts(); track alert.key) {
          <div
            (click)="openAlert(alert)"
            class="flex items-start gap-3 p-3 border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <div class="flex-1 min-w-0"
              [class.opacity-40]="notifications.isMuted(alert)"
            >
              <div class="flex items-center gap-2">
                <p class="text-sm font-medium text-gray-900">{{ alert.title }}</p>
                <span class="text-xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">{{ alert.module }}</span>
                @if (notifications.isMuted(alert)) {
                  <span class="text-xs text-gray-400 italic">némítva</span>
                }
              </div>
              <p class="text-xs text-gray-600">{{ alert.subtitle }}</p>
              <span [class]="'inline-block mt-1 px-2 py-0.5 text-xs rounded-full border ' + urgencyClass(alert.days_remaining)">
                @if (alert.days_remaining < 0) {
                  {{ -alert.days_remaining }} napja lejárt!
                } @else if (alert.days_remaining === 0) {
                  Ma jár le!
                } @else {
                  {{ alert.days_remaining }} nap
                }
              </span>
            </div>
            <div class="flex flex-col gap-1 shrink-0">
              @if (!notifications.isMuted(alert)) {
                <button (click)="dismiss($event, alert)" class="text-gray-400 hover:text-gray-600 p-1" title="Elvetés">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <button (click)="mute($event, alert)" class="text-gray-400 hover:text-red-500 p-1" title="Ne jelenjen meg többé">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                  </svg>
                </button>
              } @else {
                <button (click)="unmute($event, alert)" class="text-gray-400 hover:text-green-500 p-1" title="Értesítés visszakapcsolása">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072M18.364 5.636a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                  </svg>
                </button>
              }
            </div>
          </div>
        }
      }
    </div>
  }
</div>
